// extracted by mini-css-extract-plugin
module.exports = {"detail-modal--help-assets":"RelatedDocumentation_detail-modal--help-assets__2akKb","help-icon-pdf":"RelatedDocumentation_help-icon-pdf__3bhJh"};